import CANNON from "cannon";

let instance = null;

class GroundMaterial {

    constructor() {
        if(!instance)
        {
            this.material = new CANNON.Material();
            instance = this;
        }
        return instance;
    }
}

export default GroundMaterial;

